import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/cross.svg';

export const IconCross = createIconComponent(Icon);
